/* eslint-disable react/no-multi-comp -- thin presentational wrappers around SectionHeader */
import React from 'react';

import SectionHeader from './SectionHeader';

export const BirthHeader = () => (
  <SectionHeader
    num={1}
    titleKey="SocioeconomicInformation:birthTitle"
    subtitleKey="SocioeconomicInformation:birthMessage"
  />
);

export const LaborHeader = () => <SectionHeader num={2} titleKey="SocioeconomicInformation:laborTitle" />;

export const WhenBuyHeader = () => <SectionHeader num={3} titleKey="SocioeconomicInformation:whenBuyTitle" />;
